import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 2rem;
  margin-left: 0;
  margin-right: 0;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: ${(props) => props.theme.navBg};
  height: ${(props) =>
    props.$minimize ? props.theme.headerMinSize : props.theme.headerMaxSize};
  transition:
    height ease-in 0.3s,
    height ease-in 0.1s;

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    flex-direction: column;
    height: auto;
    align-items: stretch;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-bottom: ${(props) => (props.$menuOpen ? '0' : '10px')};
  }
`;

export const HeaderTopRow = styled.div`
  display: contents;

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    min-height: ${(props) => props.theme.headerMinSize};
  }
`;

export const NavButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: space-between;

  &:hover {
    cursor: pointer;
  }
`;

export const DesktopNav = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    display: none;
  }
`;

export const HamburgerButton = styled.button`
  display: none;
  background: transparent;
  border: none;
  cursor: pointer;
  flex-direction: column;
  justify-content: center;
  padding: 6px;

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    display: flex;
  }
`;

export const MobileMenuItems = styled.div`
  display: none;

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    max-height: ${(props) => (props.$open ? '20rem' : '0')};
    transition: max-height 0.3s ease;
    margin-left: -1rem;
    width: calc(100% + 2rem);
  }
`;

export const MobileMenuButton = styled.button`
  background-color: transparent;
  color: ${(props) => props.theme.white};
  border: none;
  /* border-top: 1px solid rgba(255, 255, 255, 0.25); */
  cursor: pointer;
  width: 100%;
  height: 3.5rem;
  font-weight: 600;
  font-size: 1rem;
  text-align: center;
  transition: background-color 0.125s ease-in;

  &:hover {
    background-color: ${(props) => props.theme.secondaryColorDark};
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export const HeaderButton = styled.button`
  background-color: transparent;
  color: ${(props) => props.theme.white};
  border: 1px solid ${(props) => props.theme.white};
  cursor: pointer;
  width: 12rem;
  height: 3rem;
  align-self: left;
  font-weight: 600;
  font-size: 1rem;
  margin-right: 20px;
  transition: background-color 0.125s ease-in;

  &:hover {
    background-color: ${(props) => props.theme.secondaryColorDark};
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export const GeneratingSpinner = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const Logo = styled.img`
  height: auto;
  width: ${(props) =>
    props.$minimize ? props.theme.logoMinSize : props.theme.logoMaxSize};

  transition: all ease-in 0.3s;

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    width: ${(props) =>
      props.$minimize
        ? props.theme.logoMobileMinSize
        : props.theme.logoMobileMaxSize};
  }
`;
